import {
  Component,
  Host,
  h,
  Prop,
  Element
} from "@stencil/core";

/**
 * @slot - Slot for label/text content
 */
@Component({
  tag: "stzh-loader",
  styleUrl: "stzh-loader.scss",
  scoped: true
})
export class StzhLoader {
  /** Size */
  @Prop() size: "default" | "small" = "default";

  /** Label */
  @Prop() label: string = "";

  /** Hide label text visually (still anounced for screenreaders) */
  @Prop() hideLabel: boolean = false;

  @Element() element: HTMLStzhInputElement;

  render() {
    const classes = {
      "stzh-loader": true,
      "stzh-loader--hide-label": this.hideLabel,
      [`stzh-loader--size-${this.size}`]: !!this.size
    };

    return (
      <Host>
        <div class={classes}>
          <div class="stzh-loader__wrapper">
            <div class="stzh-loader__uil">
              <div class="stzh-loader__ib">
                <div class="stzh-loader__circle">
                  <div></div>
                </div>
                <div class="stzh-loader__circle">
                  <div></div>
                </div>
                <div class="stzh-loader__circle">
                  <div></div>
                </div>
                <div class="stzh-loader__circle">
                  <div></div>
                </div>
              </div>
            </div>
          </div>

          <div class="stzh-loader__label" aria-live="polite">
            {this.label ? this.label : <slot></slot>}
          </div>
        </div>
      </Host>
    );
  }
}
